<div class="w-full mx-auto mt-8 rounded-lg max-h-[90vh] flex flex-col">
  <div class="py-2 px-4 flex-shrink-0">
    <p class="titre2">{{ 'GROUP_TRAINING_MANAGEMENT.PARTICIPANTS' | translate }}</p>
  </div>
  <div class="flex-1 overflow-y-auto p-4 min-h-0">
    @if (formation.dateCompletee) {
      <div class="text-base font-medium mb-2">{{formation.prenomNompriseEnChargePar}} <span class="inline-block whitespace-nowrap rounded-full px-3 py-1 text-sm  text-yellow-600 border border-white mr-2">{{ 'GROUP_TRAINING_MANAGEMENT.PRISE_EN_CHARGE_PAR' | translate }}</span></div>
    }
    @for (participant of participants; track participant) {
      <div >
        <div class="text-base font-medium mb-2" >{{participant.prenom}} {{participant.nom}}
          @if (formation.dateCompletee && participant.estResponsableFormation) {
            <span class="inline-block whitespace-nowrap rounded-full px-3 py-1 text-sm border border-white mr-2">{{ 'GROUP_TRAINING_MANAGEMENT.RESPONSABLE_FORMATION' | translate }}</span>
          }
          @if (formation.dateCompletee && participant.estPresent) {
            <span class="inline-block whitespace-nowrap rounded-full px-3 py-1 text-sm text-green-700 border border-green-700 mr-2">{{ 'GROUP_TRAINING_MANAGEMENT.PRESENT' | translate }}</span>
          }
          @if (formation.dateCompletee && !participant.estPresent) {
            <span class="inline-block whitespace-nowrap rounded-full px-3 py-1 text-sm text-rougeNovo border border-rougeNovo mr-2">{{ 'GROUP_TRAINING_MANAGEMENT.ABSENT' | translate }}</span>
          }
        </div>
      </div>
    }
  </div>
  <div class="py-2 px-4 border-t border-gray-300 dark:border-gray-600 flex-shrink-0 flex justify-end gap-6">
    <button type="button" (click)="closeDialog()"
      class="btn-secondary-novo">
      {{ 'GROUP_TRAINING_MANAGEMENT.CLOSE' | translate }}
    </button>
  </div>
</div>
